import { Helmet } from 'react-helmet-async';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// Import

import functionlist from '../../../image/img_funclist.png';
import xicon from '../../../image/img_x.png';
import okicon from '../../../image/img_ok.png';
import infiicon from '../../../image/img_infi.png';
import bottomBG from '../../../image/bottom_bg.png';
import FreePlan from '../../../image/img_free.png';
import Discount90 from '../../../image/img_90_discount.png';
import Discount60 from '../../../image/img_60_discount.png';
import PageHeader from '../../../components/sectionComponent/PageHeader';
import ContactModal from '../../../components/CommunityComponents/Contact';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'Column',
  margin: '0 auto',
  backgroundColor: '#f5f5f5',
}));

const StyledContainer = styled('div')(({ theme }) => ({
  maxWidth: 1600,
  display: 'flex',
  flexDirection: 'Column',
  alignItems: 'center',
  margin: '0 auto',
  width: '100%',
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 1600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  margin: theme.spacing(7, 'auto'),
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  width: '100%',
}));

const StyledPlan = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  flexDirection: 'column',
  backgroundColor: '#fff',
  padding: theme.spacing(7, 5),
  borderRadius: '30px',
  flex: 0.3,
  boxShadow: theme.customShadows.card,
  margin: theme.spacing(0, 1),
  textAlign: 'center',
}));

const PlanTextH2 = styled('h2')(({ theme }) => ({
  margin: 0,
  padding: 0,
}));

const PlanStartButton = styled('button')(({ theme }) => ({
  color: '#111',
  padding: theme.spacing(2, 10),
  margin: 0,
  fontSize: '1.2rem',
  fontWeight: 'bold',
  backgroundColor: '#fff',
  border: '1px solid #ddd',
  borderRadius: '5px',
  '&:hover': {
    backgroundColor: 'rgb(26, 158, 248)',
    border: '1px solid #1A9EF8',
    color: '#fff',
  },
  cursor: 'pointer',
}));

const FreeStartButton = styled('button')(({ theme }) => ({
  color: '#fff',
  padding: '17px 81px',
  margin: 0,
  fontSize: '1.2rem',
  fontWeight: 'bold',
  backgroundColor: '#1A9EF8',
  borderRadius: '5px',
  '&:hover': {
    background:
      'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)),linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
    color: '#fff',
  },
  cursor: 'pointer',
}));

const Plandetail = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'Column',
  backgroundColor: '#fff',
  margin: theme.spacing(4, 0),
}));

const H2 = styled('h2')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontWeight: 600,
}));

const H4 = styled('h4')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontSize: '1.4rem',
}));

const P = styled('p')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontSize: '1rem',
}));

const Bgtext = styled('span')(({ theme }) => ({
  padding: '5px',
  backgroundColor: '#ddd',
  fontSize: '0.8rem',
  borderRadius: '5px',
  margin: '20px 2px 0 2px',
}));

const ButtonStyled = styled('button')(({ theme }) => ({
  color: '#111',
  padding: theme.spacing(2, 10),
  margin: 0,
  fontSize: '1.2rem',
  fontWeight: 'bold',
  backgroundColor: '#fff',
  border: '1px solid #ddd',
  borderRadius: '5px',
  cursor: 'pointer',
}));

const Licensefull = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'Column',
  margin: '0 auto',
  background:
    'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)), linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
  textAlign: 'center',
  padding: theme.spacing(7, 0),
  color: '#fff',
}));

const Toptitle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  margin: theme.spacing(7, 0, 0, 0),
}));

const Planfunc = styled('div')(({ theme }) => ({
  textAlign: 'left',
  margin: theme.spacing(7, 0, 0, 0),
}));

const Ul = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: 0,
}));

const Li = styled('li')(({ theme }) => ({
  margin: 0,
  paddingBottom: '10px',
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
}));

const LicenseTable = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'column',
}));

const Tableli = styled('li')(({ theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  display: 'flex',
  width: '100%',
  borderBottom: '1px solid #ddd',
}));
const Licenseth = styled('div')({
  width: '25%',
  textAlign: 'center',
  padding: '1rem',
  '& span': {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3px',
  },
});
const DownloadButton = styled(Button)({
  marginTop: '40px',
  fontSize: '1.2rem',
  fontWeight: 500,
  fontFamily: 'Pretendard-Regular',
  padding: '1rem 4rem',
  cursor: 'pointer',
});

// ----------------------------------------------------------------------

export default function LicensePage() {
  // 다국어
  const { t, i18n } = useTranslation(['page']);
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const navigate = useNavigate();

  const gotoRegistPage = () => {
    navigate('/license_regist', { replace: true });
  };

  const [contactModalOpen, setContactModalOpen] = React.useState(false);

  const contactHandleOpen = () => {
    setContactModalOpen(true);
  };
  const contactHandleClose = () => {
    setContactModalOpen(false);
  };

  const CheckLicense = (license) => {
    if (sessionStorage.getItem('login_info') !== null) {
      console.log('license', license);
      switch (JSON.parse(sessionStorage.getItem('login_info')).use_license) {
        case 'N/A':
          sessionStorage.setItem('select_plan', license);
          gotoRegistPage();
          break;

        case '레인드롭 무료 플랜':
          if (license === 'free') {
            alert('이미 등록된 라이센스가 있습니다.');
            navigate('/mypage', { replace: true });
          } else {
            sessionStorage.setItem('select_plan', license);
            navigate('/license_upgrade', { replace: true });
          }
          break;

        case '레인드롭 베이직 플랜':
          if (license === 'Basic_new') {
            alert('이미 등록된 라이센스가 있습니다.');
            navigate('/mypage', { replace: true });
          } else {
            sessionStorage.setItem('select_plan', license);
            navigate('/license_upgrade', { replace: true });
          }
          break;

        case '레인드롭 프로 플랜':
          if (license === 'pro_new') {
            alert('이미 등록된 라이센스가 있습니다.');
            navigate('/mypage', { replace: true });
          } else {
            sessionStorage.setItem('select_plan', license);
            navigate('/license_upgrade', { replace: true });
          }
          break;

        default:
          sessionStorage.setItem('select_plan', license);
          navigate('/license_upgrade', { replace: true });
          break;
      }
    } else {
      alert('로그인 후 이용이 가능합니다.');
      navigate('/login', { replace: true });
    }
  };

  return (
    <>
      <CssBaseline />
      <Helmet>
        <title> {t('이용안내')} | RainDrop </title>
      </Helmet>
      <PageHeader data={t('이용안내')} />
      <StyledRoot>
        <StyledContainer>
          <Toptitle>
            <h1 style={{ color: '#1A9EF8', fontWeight: 500, marginBottom: '20px', fontSize: '3rem' }}>
              {t('레인드롭과 함께 쉽고 편리한 치과기공소 관리')}
            </h1>
            <h4 style={{ fontSize: '1.8rem' }}>{t('엑셀은 이제 그만! 레인드롭으로 간편하게 관리하세요.')}</h4>
          </Toptitle>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '60px' }}>
              <TabList onChange={handleChange} aria-label="Tabs">
                <Tab sx={{ fontSize: '24px', padding: '20px 40px' }} label={t('월별 구독')} value="1" />
                <Tab sx={{ fontSize: '24px', padding: '20px 40px' }} label={t('연간 구독')} value="2" />
              </TabList>
            </Box>
            <StyledContent>
              <StyledPlan style={{ boxShadow: '0 0 0 5px #1A9EF8 inset' }}>
                <H2 style={{ color: '#1A9EF8' }}>Free Plan</H2>
                <Plandetail>
                  <H4>{t('무료 플랜')}</H4>
                  <P style={{ color: '#999' }}>
                    {t('무료 플랜으로')} <br /> {t('마음껏 사용 할 수 있어요.')}
                  </P>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Bgtext>{t('1인 기공소 적합')}</Bgtext>
                  </div>
                </Plandetail>
                <div style={{ marginBottom: '40px' }}>
                  <H2 style={{ marginTop: '29.3px' }}>{t('무료')}</H2>
                  <span style={{ color: '#999' }}>{t('언제나 무료')}</span>
                </div>
                <div>
                  <FreeStartButton
                    onClick={() => {
                      CheckLicense('free');
                    }}
                  >
                    {t('시작하기')}
                  </FreeStartButton>
                </div>
                <Planfunc>
                  <P style={{ marginBottom: '20px' }}>{t('주요 기능')}</P>
                  <ul>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('접수 월 200건 무료 제공')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('청구서 월 200건 무료 발행')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('거래처 등록 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('구성원 1명까지 추가 등록')}</p>
                    </Li>
                  </ul>
                </Planfunc>
              </StyledPlan>
              <StyledPlan>
                <H2>Basic Plan</H2>
                <Plandetail>
                  <H4>{t('베이직 플랜')}</H4>
                  <P style={{ color: '#999' }}>
                    {t('기공소를 운영하기에 완벽해요.')}
                    <br />
                    {t('기공소를 위한 표준 기능')}
                  </P>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Bgtext>{t('5인 이하의 기공소 적합')}</Bgtext>
                  </div>
                </Plandetail>
                <div style={{ marginBottom: '40px' }}>
                  <TabPanel value="1" sx={{ padding: 0 }}>
                    <div>
                      <H2 style={{ marginTop: '29.3px' }}>{t('23,900원')}</H2>
                      <span style={{ color: '#999' }}>{t('월별(매월 청구)')}</span>
                    </div>
                  </TabPanel>
                  <TabPanel value="2" sx={{ padding: 0 }}>
                    <H2>
                      <p style={{ textDecoration: 'line-through', fontSize: '1.4rem', color: '#999' }}>
                        {t('286,800원')}
                      </p>
                      <span style={{ color: '#1A9EF8' }}>{t('239,000원')}</span>
                    </H2>
                    <span style={{ color: '#999' }}>{t('연간(매년 청구)')}</span>
                  </TabPanel>
                </div>
                <div>
                  <PlanStartButton
                    onClick={() => {
                      CheckLicense('Basic_new');
                    }}
                  >
                    {t('시작하기')}
                  </PlanStartButton>
                </div>
                <Planfunc>
                  <P style={{ marginBottom: '20px' }}>{t('주요 기능')}</P>
                  <ul>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('접수 월 500건 무료 제공')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('청구서 월 500건 무료 발행')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('거래처 등록 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('구성원 5명까지 추가 등록')}</p>
                    </Li>
                  </ul>
                </Planfunc>
              </StyledPlan>
              <StyledPlan>
                <H2>Pro Plan</H2>
                <Plandetail>
                  <H4>{t('프로 플랜')}</H4>
                  <P style={{ color: '#999' }}>
                    {t('기공소를 더욱 더 발전시켜보세요.')}
                    <br />
                    {t('표준 기능에 고급 기능까지')}
                  </P>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Bgtext>{t('5인 이상의 기공소 적합')}</Bgtext>
                  </div>
                </Plandetail>
                <div style={{ marginBottom: '40px' }}>
                  <TabPanel value="1" sx={{ padding: 0 }}>
                    <div>
                      <H2 style={{ marginTop: '29.3px' }}>{t('48,900원')}</H2>
                      <span style={{ color: '#999' }}>{t('월별(매월 청구)')}</span>
                    </div>
                  </TabPanel>
                  <TabPanel value="2" sx={{ padding: 0 }}>
                    <H2>
                      <p style={{ textDecoration: 'line-through', fontSize: '1.4rem', color: '#999' }}>
                        {t('586,800원')}
                      </p>
                      <span style={{ color: '#1A9EF8' }}>{t('489,000원')}</span>
                    </H2>
                    <span style={{ color: '#999' }}>{t('연간(매년 청구)')}</span>
                  </TabPanel>
                </div>
                <div>
                  <PlanStartButton
                    onClick={() => {
                      CheckLicense('pro_new');
                    }}
                  >
                    {t('시작하기')}
                  </PlanStartButton>
                </div>
                <Planfunc>
                  <P style={{ marginBottom: '20px' }}>{t('주요 기능')}</P>
                  <ul>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('접수 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('청구서 발행 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('거래처 등록 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('구성원 권한 설정 및 등록 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('데이터베이스 자동 백업')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('매출 통계 제공')}</p>
                    </Li>
                  </ul>
                </Planfunc>
              </StyledPlan>

              <StyledPlan>
                <H2>MES</H2>
                <Plandetail>
                  <H4>{t('정부지원사업')}</H4>
                  <P style={{ color: '#999' }}>
                    {t('정부지원사업 진행을 위한')}
                    <br />
                    {t('표준 기능(커스터마이징)')}
                  </P>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Bgtext>{t('10인 미만의 기공소 적합')}</Bgtext>
                  </div>
                </Plandetail>
                <div style={{ marginBottom: '30px' }}>
                  <TabPanel value="1" sx={{ padding: 0 }}>
                    <H2 style={{ marginTop: '0' }}>
                      <span style={{ color: '#1A9EF8' }}>{t('200만원')}</span>
                    </H2>
                    <p style={{ color: '#999' }}>{t('6개월 이상')}</p>
                    <p style={{ color: '#999' }}>{t('1개월에서 5개월')}</p>
                    <p style={{ color: '#999' }}>{t('사업 종료 후 서버 비용만 청구')}</p>
                  </TabPanel>
                  <TabPanel value="2" sx={{ padding: 0 }}>
                    <H2 style={{ marginTop: '0' }}>
                      <span style={{ color: '#1A9EF8' }}>{t('2,400만원')}</span>
                    </H2>
                    <p style={{ color: '#999' }}>{t('6개월 이상')}</p>
                    <p style={{ color: '#999' }}>{t('1개월에서 5개월')}</p>
                    <p style={{ color: '#999' }}>{t('사업 종료 후 서버 비용만 청구')}</p>
                  </TabPanel>
                </div>
                <div>
                  <PlanStartButton onClick={contactHandleOpen}>{t('문의')}</PlanStartButton>
                </div>
                <Planfunc>
                  <P style={{ marginBottom: '20px' }}>{t('주요 기능')}</P>
                  <ul>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('스마트장비 생산데이터 KPI 연동')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('커스터마이징')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('접수 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('청구서 발행 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('거래처 등록 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('구성원 권한 설정 및 등록 무제한')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('데이터베이스 자동 백업')}</p>
                    </Li>
                    <Li>
                      <img src={functionlist} alt="functionlist" />
                      <p style={{ paddingLeft: '5px' }}>{t('매출 통계 제공')}</p>
                    </Li>
                  </ul>
                </Planfunc>
              </StyledPlan>
            </StyledContent>
          </TabContext>
        </StyledContainer>
      </StyledRoot>
      <Licensefull>
        <H2>{t('플랜 선택이 고민된다면 무료 체험부터')}</H2>
        <P sx={{ fontSize: '1.2rem', marginTop: '10px' }}>
          {t('어떤 플랜을 선택할지 고민이신가요 ? 무료 체험 후 결정하세요!')}
        </P>
      </Licensefull>
      <StyledRoot sx={{ marginBottom: '60px', backgroundColor: '#fff' }}>
        <StyledContainer>
          <div>
            <h2 style={{ margin: '56px 0' }}>{t('플랜 별 상세 기능')}</h2>
          </div>
          <div style={{ width: '100%', border: '1px solid #ddd', borderRadius: '10px', padding: '56px' }}>
            <div>
              <LicenseTable>
                <Tableli>
                  <Licenseth>&nbsp;</Licenseth>
                  <Licenseth>
                    <h4>Free Plan</h4>
                  </Licenseth>
                  <Licenseth>
                    <h4>Basic Plan</h4>
                  </Licenseth>
                  <Licenseth>
                    <h4>Pro Plan</h4>
                  </Licenseth>
                  <Licenseth>
                    <h4>MES</h4>
                  </Licenseth>
                </Tableli>
              </LicenseTable>
            </div>
            <div>
              <h4 style={{ padding: '1.6rem 1rem 1rem 1rem', borderBottom: '1px solid #ddd' }}>{t('생산성')}</h4>
              <LicenseTable>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('접수')}</Licenseth>
                  <Licenseth>200</Licenseth>
                  <Licenseth>500</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                </Tableli>
                <Tableli>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('청구서 발행')}</Licenseth>
                  <Licenseth>200</Licenseth>
                  <Licenseth>500</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                </Tableli>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('거래처 등록')}</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                </Tableli>
              </LicenseTable>
            </div>
            <div>
              <h4 style={{ padding: '1.6rem 1rem 1rem 1rem', borderBottom: '1px solid #ddd' }}>{t('계정')}</h4>
              <LicenseTable>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('관리자')}</Licenseth>
                  <Licenseth>1</Licenseth>
                  <Licenseth>1</Licenseth>
                  <Licenseth>1</Licenseth>
                  <Licenseth>1</Licenseth>
                </Tableli>
                <Tableli>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('구성원')}</Licenseth>
                  <Licenseth>1</Licenseth>
                  <Licenseth>5</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={infiicon} alt="infi" />
                    </span>
                  </Licenseth>
                </Tableli>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('권한 설정')}</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>{t('페이지 별 접근 권한 관리')}</Licenseth>
                  <Licenseth>{t('페이지 별 접근 권한 관리')}</Licenseth>
                </Tableli>
              </LicenseTable>
            </div>
            <div>
              <h4 style={{ padding: '1.6rem 1rem 1rem 1rem', borderBottom: '1px solid #ddd' }}>{t('서버 및 보안')}</h4>
              <LicenseTable>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('데이터서버')}</Licenseth>
                  <Licenseth>{t('슈가폴 클라우드(2GB)')}</Licenseth>
                  <Licenseth>{t('슈가폴 클라우드(5GB)')}</Licenseth>
                  <Licenseth>{t('슈가폴 클라우드(무제한)')}</Licenseth>
                  <Licenseth>{t('슈가폴 클라우드(무제한)')}</Licenseth>
                </Tableli>
                <Tableli>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('백업')}</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>{t('전체 DB 백업(1회)')}</Licenseth>
                  <Licenseth>{t('전체 DB 백업(주3회 자동 백업)')}</Licenseth>
                  <Licenseth>{t('전체 DB 백업(주3회 자동 백업)')}</Licenseth>
                </Tableli>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('보안')}</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>{t('2중 보안 시스템')}</Licenseth>
                  <Licenseth>{t('2중 보안 시스템')}</Licenseth>
                </Tableli>
              </LicenseTable>
            </div>
            <div>
              <h4 style={{ padding: '1.6rem 1rem 1rem 1rem', borderBottom: '1px solid #ddd' }}>{t('추가 기능')}</h4>

              <LicenseTable>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('전자세금계산서 발행')}</Licenseth>
                  <Licenseth>{t('유료 결제')}</Licenseth>
                  <Licenseth>{t('유료 결제')}</Licenseth>
                  <Licenseth>{t('10건(최초 1회 가입 시)')}</Licenseth>
                  <Licenseth>{t('문의')}</Licenseth>
                </Tableli>
                <Tableli>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('청구서 이메일 발송')}</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={okicon} alt="ok" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={okicon} alt="ok" />
                    </span>
                  </Licenseth>
                </Tableli>
                <Tableli>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('커스터마이징')}</Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={xicon} alt="x" />
                    </span>
                  </Licenseth>
                  <Licenseth>
                    <span>
                      <img src={okicon} alt="ok" />
                    </span>
                  </Licenseth>
                </Tableli>
              </LicenseTable>
            </div>
            <div>
              <h4 style={{ padding: '1.6rem 1rem 1rem 1rem', borderBottom: '1px solid #ddd' }}>{t('고객지원')}</h4>
              <LicenseTable>
                <Tableli style={{ backgroundColor: '#f5f5f5' }}>
                  <Licenseth style={{ textAlign: 'left', paddingLeft: '40px' }}>{t('문의')}</Licenseth>
                  <Licenseth>{t('게시판 문의')}</Licenseth>
                  <Licenseth>{t('게시판 문의(24시간 내 답변)')}</Licenseth>
                  <Licenseth>{t('게시판 문의(6시간 내 답변)')}</Licenseth>
                  <Licenseth>{t('게시판 문의(6시간 내 답변)')}</Licenseth>
                </Tableli>
              </LicenseTable>
            </div>
          </div>
        </StyledContainer>
      </StyledRoot>
      <Licensefull sx={{ background: `url(${bottomBG}) no-repeat bottom center`, alignItems: 'center' }}>
        <H2>{t('아직 회원이 아니신가요?')}</H2>
        <P sx={{ fontSize: '1.2rem', marginTop: '10px' }}>{t('회원가입도 간편하게 지금 바로 등록하세요.')}</P>
        <DownloadButton href="/login" sx={{ backgroundColor: '#4E45F5', color: '#fff', border: 'none' }}>
          {t('간편 회원가입')}
        </DownloadButton>
      </Licensefull>
      <ContactModal modalOpen={contactModalOpen} pContactHandleClose={contactHandleClose} />
    </>
  );
}
